import { Divider, Link, Text } from "@chakra-ui/react";
import React from "react";

const SupportArea = () => (
  <>
    <Divider />
    <Text>
      Please feel free to contact us using the chat in the bottom-right corner
      of this page, or email{" "}
      <Link to="mailto:support@makerkids.com" isExternal>
        support@makerkids.com
      </Link>
      .
    </Text>
  </>
);

export default SupportArea;

